var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptopMedical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_laptop-medical",
    "data-name": "Icon - laptop-medical",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "laptop-medical",
    d: "M15.6,40.4H14.4V33.6A1.6,1.6,0,0,0,12.8,32H3.2a1.6,1.6,0,0,0-1.6,1.6v6.8H.4a.4.4,0,0,0-.4.4V42a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V40.8A.4.4,0,0,0,15.6,40.4ZM2.4,33.6a.8.8,0,0,1,.8-.8h9.6a.8.8,0,0,1,.8.8v6.8H9.778a.21.21,0,0,0-.2.177.8.8,0,0,1-.78.623H7.2a.8.8,0,0,1-.78-.623.209.209,0,0,0-.2-.177H2.4ZM15.2,42A1.2,1.2,0,0,1,14,43.2H2A1.2,1.2,0,0,1,.8,42v-.8H5.669A1.2,1.2,0,0,0,6.8,42H9.2a1.2,1.2,0,0,0,1.131-.8H15.2Zm-8-3a.2.2,0,0,0,.2.2H8.6a.2.2,0,0,0,.2-.2V37.6h1.4a.2.2,0,0,0,.2-.2V36.2a.2.2,0,0,0-.2-.2H8.8V34.6a.2.2,0,0,0-.2-.2H7.4a.2.2,0,0,0-.2.2V36H5.8a.2.2,0,0,0-.2.2v1.2a.2.2,0,0,0,.2.2H7.2Z",
    transform: "translate(0 -32)",
    fill: "#0078c9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptopMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop-medical.ed871d90f4bd312482ac5e4942af1958.svg";